import { render, staticRenderFns } from "./companyProfileSet.vue?vue&type=template&id=1f271f13&scoped=true&"
import script from "./companyProfileSet.vue?vue&type=script&lang=js&"
export * from "./companyProfileSet.vue?vue&type=script&lang=js&"
import style0 from "./companyProfileSet.vue?vue&type=style&index=0&id=1f271f13&prod&scoped=true&lang=css&"
import style1 from "./companyProfileSet.vue?vue&type=style&index=1&id=1f271f13&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f271f13",
  null
  
)

export default component.exports